export class User {
  user_code: string;
  email?: string;
  token?: string;
  first_name: string;
  last_name: string;
  security_permissions: object;


  clear(): void {
    this.user_code = '';
    this.email = '';
    this.token = '';
  }

  constructor() {}
}
